<template>
    <div>
        <div class="popup__content popup__content--pt-small">
            <template v-if="step === 1">
                <h3 class="title title--s create__body-title">{{ $lang('formPage.title') }}</h3>
                <el-form ref="createPageForm" class="form" v-model="form" @submit.native.prevent="submitForm('ruleForm')">
                    <div class="form__item upload-photo form__item--big-margin">
                        <label class="form__label">{{ $lang('formPage.lable1') }}</label>
                        <div class="upload-photo__inner">
                            <div class="form__inner upload-photo__avatar-box">
                                <label class="btn upload-photo__avatar-upload" v-if="!imgSrc && form.main_image == null && !load">
                                    <input type="file" accept="image/*" class="upload-photo__input" @change="setImage">
                                    <span class="upload-photo__avatar-inner">
                                        <svg width="21" height="21">
                                        <use xlink:href="/assets/front/img/sprite.svg#icon-camera"></use>
                                    </svg>
                                    <span class="upload-photo__avatar-text">{{ $lang('formPage.button.add') }}</span>
                                    </span>
                                </label>
                                <img src="/assets/front/img/spinner.svg" v-if="imgSrc == null && load" style="width:280px; height:280px">
                                <el-popover v-if="imgSrc && form.main_image == null"
                                            v-model="errors.cropper_main_image.isError"
                                            trigger="manual"
                                            placement="top"
                                            width="200"
                                            popper-class="add__error-popover"
                                            :content="errors.cropper_main_image.message">
                                    <vue-cropper id="cropper_main_image"
                                                 slot="reference"
                                                 ref="cropper"
                                                 :guides="true"
                                                 :view-mode="2"
                                                 drag-mode="crop"
                                                 :auto-crop-area="0.5"
                                                 :min-container-width="300"
                                                 :min-container-height="300"
                                                 :background="true"
                                                 :rotatable="false"
                                                 :src="imgSrc"
                                                 :img-style="{ 'width': '300px', 'height': '300px' }"
                                                 :aspect-ratio="1"
                                    ></vue-cropper>
                                </el-popover>
                                <button type="button" @click="cropImage" v-if="imgSrc && form.main_image == null"
                                        style="margin-top: 10px;" class="btn btn--small btn--main-bg add__video-button">
                                    {{ $lang('formPage.button.crop') }}
                                </button>
                                <img v-if="form.main_image" :src="form.main_image" class="upload-photo__avatar-base">
                                <button type="button" @click="deleteImage" v-if="form.main_image"
                                        style="margin-top: 10px;"
                                        class="btn btn--small btn--main-bg add__video-button">{{ $lang('formPage.button.delete') }}
                                </button>
                            </div>
                            <div class="form__inner">
                                <span class="upload-photo__hint upload-photo__hint--m">{{ $lang('formPage.lable1.description') }}</span>
                            </div>
                        </div>
                    </div>
                    <label class="form__item">
                        <span class="form__label">{{ $lang('formPage.lable2') }}</span>
                        <el-popover v-model="errors.name.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="200"
                                    popper-class="add__error-popover"
                                    :content="errors.name.message">
                            <el-input slot="reference"
                                      id="name"
                                      class="input input--big"
                                      :class="{ 'add__error': errors.name.isErrorPaint }"
                                      :placeholder="$lang('formPage.lable2.placeholder')"
                                      v-model="form.name"
                                      required
                                      :clearable="false"
                                      dusk="name"
                                      @focus="clearErrorsValid"
                            />
                        </el-popover>
                    </label>
                    <div class="form__item">
                        <span class="form__label">{{ $lang('formPage.lable3') }}</span>
                        <div class="date">
                            <el-popover id="start.day" v-model="errors.start.day.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.start.day.message">
                                <el-select dusk="start-day"
                                           slot="reference"
                                           :placeholder="$lang('formPage.placeholder.day')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__date"
                                           :class="{ 'add__error': errors.start.day.isErrorPaint }"
                                           v-model="form.start.day" required :clearable="false"
                                           @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in dates"
                                               :key="index"
                                               :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-popover>

                            <el-popover id="start.month" v-model="errors.start.month.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.start.month.message">
                                <el-select dusk="start-month"
                                           slot="reference"
                                           :placeholder="$lang('formPage.placeholder.month')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__month"
                                           :class="{ 'add__error': errors.start.month.isErrorPaint }"
                                           v-model="form.start.month"
                                           required
                                           :clearable="false"
                                           @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in months"
                                               :key="index"
                                               :label="item.name"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-popover>

                            <el-popover id="start.year" v-model="errors.start.year.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.start.year.message">
                                <el-select dusk="start-year" slot="reference" :placeholder="$lang('formPage.placeholder.year')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__year"
                                           :class="{ 'add__error': errors.start.year.isErrorPaint }"
                                           v-model="form.start.year" required :clearable="false"
                                           @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in years"
                                               :key="index"
                                               :label="item"
                                               :value="item">
                                    </el-option>
                                </el-select>
                            </el-popover>
                        </div>
                    </div>
                    <div class="form__item" id="end">
                        <span class="form__label">{{ $lang('formPage.lable4') }}</span>
                        <div class="date">
                            <el-popover id="end.day" v-model="errors.end.day.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.end.day.message">
                                <el-select dusk="end-day" slot="reference" :placeholder="$lang('formPage.placeholder.day')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__date"
                                           :class="{ 'add__error': errors.end.day.isErrorPaint }"
                                           v-model="form.end.day" required :clearable="false" @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in dates"
                                               :key="index"
                                               :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-popover>

                            <el-popover id="end.month" v-model="errors.end.month.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.end.month.message">
                                <el-select dusk="end-month"
                                           slot="reference"
                                           :placeholder="$lang('formPage.placeholder.month')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__month"
                                           :class="{ 'add__error': errors.end.month.isErrorPaint }"
                                           v-model="form.end.month" required :clearable="false"
                                           @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in months"
                                               :key="index"
                                               :label="item.name"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-popover>

                            <el-popover id="end.year" v-model="errors.end.year.isError"
                                        trigger="manual"
                                        placement="top"
                                        width="200"
                                        popper-class="add__error-popover"
                                        :content="errors.end.year.message">
                                <el-select dusk="end-year" slot="reference" :placeholder="$lang('formPage.placeholder.year')"
                                           :loading-text="$lang('el-select.loading')"
                                           :noDataText="$lang('el-select.noDataText')"
                                           :noMatchText="$lang('el-select.noMatchText')"
                                           class="date__year"
                                           :class="{ 'add__error': errors.end.year.isErrorPaint }"
                                           v-model="form.end.year" required :clearable="false"
                                           @focus="clearErrorsValid">
                                    <el-option v-for="(item, index) in years"
                                               :key="index"
                                               :label="item"
                                               :value="item">
                                    </el-option>
                                </el-select>
                            </el-popover>
                        </div>
                    </div>
                    <label class="form__item">
                        <span class="form__label">{{ $lang('formPage.lable5') }}</span>
                        <el-popover v-model="errors.epitaph.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="200"
                                    popper-class="add__error-popover"
                                    :content="errors.epitaph.message">
                            <el-input
                                dusk="epitaph"
                                id="epitaph"
                                slot="reference"
                                class="input input--big"
                                :rows="11"
                                type="textarea"
                                :class="{ 'add__error': errors.epitaph.isErrorPaint }"
                                :placeholder="placeholder"
                                v-model="form.epitaph"
                                required
                                :maxlength="300"
                                :clearable="false"
                                @focus="clearErrorsValid"
                            />
                        </el-popover>
                    </label>
                    <label class="form__item">
                        <span class="form__label">{{ $lang('formPage.lable6') }}</span>
                        <el-popover v-model="errors.author_epitaph.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="200"
                                    popper-class="add__error-popover"
                                    :content="errors.author_epitaph.message">
                            <el-input
                                id="author_epitaph"
                                dusk="author-epitaph"
                                slot="reference"
                                :class="{ 'add__error': errors.author_epitaph.isErrorPaint }"
                                @focus="clearErrorsValid"
                                class="input input--small"
                                :placeholder="$lang('formPage.lable6.placeholder')"
                                v-model="form.author_epitaph"
                                clearable
                            />
                        </el-popover>
                    </label>
                </el-form>
            </template>

            <template v-if="step === 2">
                <div class="create__section create__section--short create__section--gray">
                    <span dusk="create-success-short" class="create__success" v-if="!burial">{{ getSuccessTitle(pageType) }}</span>

                    <span class="create__success"
                          v-if="burial">{{ $lang('formPage.success.description') }}</span>
                    <span class="create__description" v-html="text()"></span>
                </div>

                <div v-if="pageType === pageTypes.full && user">
                    <delivery-location :delivery.sync="delivery" @noTable="noTable = true"></delivery-location>
                </div>

                <register v-if="type === 'register' && !user" :pageType="pageType" :price="price" :burial="burial"
                          :paymentType="paymentType" v-on:create:page="auth($event)">
                </register>

                <login v-if="type === 'login' && !user" :pageType="pageType" :price="price" :burial="burial"
                       :paymentType="paymentType" v-on:create:page="auth($event)"></login>

                <reset v-if="type === 'reset' && !user"></reset>
            </template>

            <template v-if="step === 3">
                <delivery-order
                    :hiddenPromoCode="!!utmPromo"
                    :delivery.sync="delivery"
                    :order="order"
                    :product-name="pageTypeName"
                    :product-price="price"
                    :payment-type="paymentType"
                    :copyright="copyright"
                    :title.sync="title"
                    @back="backToLocation"
                    @onSubmit="sendOrder"
                />
            </template>
        </div>

        <template v-if="step === 1 || user">
            <div class="popup__footer" v-if="step === 1 || user">
                <template v-if="isVip && user">
                    <button dusk="further" class="btn btn--middle btn--main-bg" @click.prevent="createVip('ruleForm', true)" style="margin-bottom: 10px;">
                        {{ $lang('formPage.success.button.save') }}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button class="btn btn--middle btn--main-bg" @click.prevent="createVip('ruleForm')" style="margin-bottom: 10px;">
                        {{ $lang('formPage.success.button.saveAndСontinue') }}
                    </button>
                </template>
                <template v-else-if="step === 1 && subscriptionId && isActiveSubscription && pageTypes.full && price !== priceBurial && price !== priceWithCopy">
                    <button dusk="further" class="btn btn--middle btn--main-bg" @click.prevent="checkSubscription()">
                        {{ $lang('formPage.success.button.сontinue') }}
                    </button>
                </template>
                <template v-else>
                    <button dusk="further" v-if="step === 1" class="btn btn--middle btn--main-bg" @click.prevent="submitForm('ruleForm')">
                        {{ $lang('formPage.success.button.сontinue') }}
                    </button>

                    <template v-if="step === 2">
                        <template v-if="pageType === pageTypes.short && user">
                            <button class="popup__footer-item btn btn--middle btn--main-bg" @click.prevent="createAndRedirectToPages">
                                {{ $lang('formPage.success.button.ok') }}
                            </button>

                            <button class="popup__footer-item btn btn--middle btn--border-bg" @click.prevent="create">
                                {{ $lang('formPage.success.button.goToEditing') }}
                            </button>
                        </template>
                    </template>
                </template>
            </div>
        </template>

        <exists-page-message :value="creatingErrors"></exists-page-message>
    </div>
</template>

<script>
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
import Register from "./section/register";
import Login from "./section/login";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import errors from '../../mixins/errors'
import validator from '../../mixins/validator';
import helper from '../../mixins/helper';
import dayjs from "dayjs";
import Reset from "./section/reset";
import ExistsPageMessage from "../../components/ExistsPageMessage";
import Vue from "vue";
import DeliveryLocation from "../delivery/DeliveryLocation";
import DeliveryOrder from "../delivery/DeliveryOrder";
import { reachGoalOplatit } from "../../utils/yandex-metrica";

export default {
    name: "FormPage",
    props: [
        'pageType', 'paymentType', 'price', 'master', 'responsible', 'partner',
        'burial', 'burial_id', 'copyright', 'notRedirect', 'title', 'utmPromo', 'qrHidden'
    ],
    mixins: [errors, helper, validator],
    components: {Reset, Login, Register, VueCropper, ExistsPageMessage, DeliveryLocation, DeliveryOrder},
    data: () => ({
        locale: window.laravel.locale,
        isMaster: window.laravel.isMaster,
        isAdmin: window.laravel.isAdmin,
        isPartner: window.laravel.isPartner,
        isResponsible: window.laravel.isResponsible,
        isRole: window.laravel.isRole,
        creatingErrors: [],
        paymentTypes: window.laravel.paymentTypes,
        pageTypes: window.laravel.pageTypes,
        forceRedirectToPath: null,
        subscriptionId: window.laravel.subscription?.id || null,
        isActiveSubscription: window.laravel.subscription?.active_at || null,
        priceWithCopy: parseInt(window.laravel.prices.fullWithCopyright.price),
        priceBurial: parseInt(window.laravel.prices.burial.price),
        toPA: false,
        imgSrc: null,
        avatar: true,
        load: false,
        placeholder: Vue.prototype.$lang('formPage.lable5.placeholder'),
        masterRules: {
            name: [
                {required: true, message: Vue.prototype.$lang('formPage.rule1')},
                {min: 3, max: 255, message: Vue.prototype.$lang('formPage.rule2')}
            ],
            epitaph: [
                {max: 240, message: Vue.prototype.$lang('formPage.rule3')}
            ],
            start: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                },
            },
            end: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                }
            },
            author_epitaph: [
              {max: 255, message: Vue.prototype.$lang('formPage.rule8')}
            ],
        },
        responsibleRules: {
            name: [
                {required: true, message: Vue.prototype.$lang('formPage.rule1')},
                {min: 3, max: 255, message: Vue.prototype.$lang('formPage.rule2')}
            ],
            start: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                },
            },
            end: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                }
            },
            epitaph: [
                {max: 240, message: Vue.prototype.$lang('formPage.rule3')}
            ],
            author_epitaph: [
              {max: 255, message: Vue.prototype.$lang('formPage.rule8')}
            ],
        },
        rules: {
            name: [
                {required: true, message: Vue.prototype.$lang('formPage.rule1')},
                {min: 3, max: 255, message: Vue.prototype.$lang('formPage.rule2')}
            ],
            start: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                },
            },
            end: {
                type: 'object',
                required: true,
                fields: {
                    day: {required: true, message: Vue.prototype.$lang('formPage.rule4')},
                    month: {required: true, message: Vue.prototype.$lang('formPage.rule5')},
                    year: {type: 'number', required: true, message: Vue.prototype.$lang('formPage.rule6')},
                }
            },
            epitaph: [
                {required: true, message: Vue.prototype.$lang('formPage.rule7')},
                {max: 240, message: Vue.prototype.$lang('formPage.rule3')}
            ],
            author_epitaph: [
                {max: 255, message: Vue.prototype.$lang('formPage.rule8')}
            ],
        },
        cropperRules: {
            cropper_main_image: {
                type: 'boolean',
                validator: (rule, value, cb) => {
                    if(value) {
                        cb();
                    } else {
                        cb(new Error(Vue.prototype.$lang('formPage.cropper')));
                    }
                },
            }
        },
        errors: {
            name: {isError: false, isErrorPaint: false, message: ''},
            epitaph: {isError: false, message: ''},
            author_epitaph: {isError: false, message: ''},
            header: {isError: false, message: ''},
            start: {
                year: {isError: false, message: ''},
                day: {isError: false, message: ''},
                month: {isError: false, message: ''},
            },
            end: {
                year: {isError: false, message: ''},
                day: {isError: false, message: ''},
                month: {isError: false, message: ''},
            },
            cropper_main_image: {isError: false, message: ''},
        },
        delivery: null,
        order: null,
        noTable: false,
        submitBlocked: false
    }),
    computed: {
        ...mapGetters('reference', [
            'years',
            'dates',
            'months'
        ]),
        ...mapState('auth', [
            'formAuth',
            'user',
        ]),
        ...mapState('create', [
            'form',
            'type',
            'step',
            'modal'
        ]),
        pageSlug() {
            let urlParams = new URLSearchParams(window.location.search);

            return urlParams.get('slug');
        },
        isPartnerBlank() {
            return this.$route.query.isPartnerBlank ?? false;
        },
        isVip() {
            let urlParams = new URLSearchParams(window.location.search);

            return urlParams.get('is_vip');
        },
        pageTypeName() {
            return (this.burial || this.paymentType === this.paymentTypes.burial)
                ? Vue.prototype.$lang('formPage.success.type.burial')
                : Vue.prototype.$lang('formPage.success.type.full')
        }
    },
    mounted() {
        if (this.step === 2 && this.pageType !== this.pageTypes.short) {
            this.setModal(1200);
        } else {
            this.setModal(800);
        }

        this.$nextTick(() => {
            const form = this.$refs.createPageForm && this.$refs.createPageForm.$el;

            if (form) {
                form.id = "create-page-form";
            }
        });

        this.$emit('update:title', this.$lang('formPage.title2'));
    },
    methods: {
        ...mapActions('create', [
            'createPage',
            'checkDuplicatePage',
            'checkShortPageLimit'
        ]),
        ...mapMutations('create', [
            'setPageType',
            'setSubscriptionId',
            'setStep',
            'setIds',
            'setBurialId',
            'setModal'
        ]),
        create() {
            this.$set(this.form, 'withCopyright', this.copyright);
            this.$set(this.form, 'qr_hidden', this.qrHidden);

            this.setPageType(this.pageType);

            let burial = {
                flag: this.burial,
                id: this.burial_id
            };
            this.setBurialId(burial);

            if (this.user) {
                let ids = {
                    master_id: this.master ? this.master : null,
                    user_id: this.responsible ? this.responsible : this.user.id,
                    partner_id: this.partner ? this.partner : null,
                };
                this.setIds(ids);
            }

            this.checkShortPageLimit()
                .then(() => {
                    this.createPage(this.pageSlug)
                        .then((response) => {
                            if (this.isAdmin) {
                                this.redirectTo("/cabinet/page/" + response.data.slug);
                            } else if (this.isPartner || this.isMaster) {
                                if (this.notRedirect) {
                                    this.redirectTo( '/cabinet/responsibles');
                                } else {
                                    this.redirectTo(this.burial ? '/cabinet/pages/related' : '/cabinet/pages');
                                }
                            } else if ((this.isResponsible && this.isPartnerBlank) || (this.pageType === this.pageTypes.full)) {
                                if (this.copyright) {
                                    this.$dataLayer.push({'event': 'redirectToPay', 'title': 'РаК'});
                                } else {
                                    this.$dataLayer.push({'event': 'redirectToPay', 'title': 'Ра'});
                                }

                                this.pay(response.data.id);
                            } else if (this.toPA) {
                                this.redirectTo("/cabinet/pages");
                            } else {
                                this.$nextTick(() => {
                                    this.$dataLayer.push({'event': 'freePageCreated', 'title': 'Кр'});
                                    roistat.event.send('short_page_created');
                                });

                                this.redirectTo(this.forceRedirectToPath ?? "/cabinet/page/" + response.data.slug);
                            }
                        })
                        .catch((error) => {
                            if (error.response.status === 400) {
                                /*редирект, если создается с главной мастером без уазания ответственного*/
                                this.redirectTo('/cabinet/pages');
                            }

                            this.creatingErrors = error.response.data;
                        });
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        //Редирект на форму если достигли лимит кратких страниц
                        this.$router.push({name: 'shortPageLimit'});
                    }
                });
        },
        pay(page_id) {
            let params = {
                product_name: this.pageTypeName,
                product_price: this.price,
                page_id: page_id,
                payment_type: this.paymentType,
                price: this.order ? this.order.sum : this.price,
                phone: this.order?.phone,
                copyright: !!this.copyright,
                burial: !!this.burial,
                no_table: this.noTable,
                locale: this.locale,
                subscription_id: this.subscriptionId
            };

            if (this.utmPromo) {
              params.utm_promo = this.utmPromo;
            }

            if(this.delivery) {
                this.$set(params, 'delivery_target', this.delivery.target);
                this.$set(params, 'delivery_period', this.delivery.period);
                this.$set(params, 'delivery_workschedule', this.delivery.workschedule);
                this.$set(params, 'delivery_method', this.delivery.method);
                this.$set(params, 'delivery_method_name', this.delivery.methodName);
                this.$set(params, 'delivery_price', this.delivery.price);
                this.$set(params, 'delivery_address', this.delivery.address);
                this.$set(params, 'plate_attachment', this.order.plateAttachment);
            }

            if (this.order && this.order.promoCodeId) {
                this.$set(params, 'promo_code_id', this.order.promoCodeId);
            }

            params = new URLSearchParams(params);

            this.redirectTo(`/payment?${params.toString()}`);
        },
        submitForm(formName) {
            reachGoalOplatit("formPage submitForm");

            let rules = this.rules;
            // Если текущий пользователь либо админ/мастер/партрен
            if (this.isAdmin || this.isMaster || this.isPartner) {
                // обязательными полями будут FIO и эпитафия
                rules = this.masterRules;
            }

            // Если ответственный воспользовался партнерской табличкой
            if (this.isResponsible && this.isPartnerBlank) {
                // обязательным полем будет только FIO
                rules = this.responsibleRules;
            }

            const validator = { ...this.cropperRules, ...rules };

            this.validate(() => {
                if (this.submitBlocked) {
                    return;
                }

                this.submitBlocked = true;

                if (this.validateDate()) {
                    // Если текущий пользователь админ/мастер/партнер/ответственный, что отсканировал партнерскую табличку
                    if (this.isMaster || this.isAdmin || this.isPartner || (this.isResponsible && this.isPartnerBlank)) {
                        this.create();
                    } else {
                        this.checkDuplicatePage(this.form)
                            .then(() => {
                                if(this.pageType === 1) {
                                    if(this.copyright) {
                                        this.$dataLayer.push({'event': 'userDataPopup', 'title': 'РаК'});
                                    } else {
                                        this.$dataLayer.push({'event': 'userDataPopup', 'title': 'Ра'});
                                    }
                                } else if(this.pageType === 2) {
                                    this.$dataLayer.push({'event': 'userDataPopup', 'title': 'Кр'});
                                }

                                this.setStep(2);
                            })
                            .catch((error) => {
                                this.submitBlocked = false;

                                this.creatingErrors = error.response.data;
                            });
                    }
                } else {
                    this.submitBlocked = false;

                    this.$appNotify.error(Vue.prototype.$lang('formPage.error1'));
                }
            }, {...this.form}, false, validator);
        },
        createVip(formName, toPA) {
            reachGoalOplatit("formPage createVip");

            let rules = (this.isAdmin || this.isMaster || this.isPartner)
                ? this.masterRules
                : this.rules;

            const validator = { ...this.cropperRules, ...rules };

            this.validate(() => {
                if (this.validateDate()) {
                    this.toPA = toPA;
                    this.create();
                } else {
                    this.$appNotify.error(Vue.prototype.$lang('formPage.error1'));
                }
            }, {...this.form}, false, validator);
        },
        setImage(e) {
            this.load = true;

            const file = e.target.files[0];

            if (!file.type.includes("image/")) {
                alert("Please select an image file");
                this.load = false;
                return;
            }
            if (typeof FileReader === "function") {
                const reader = new FileReader();

                reader.onload = event => {
                    this.downscaleImage(event.srcElement.result, 870, file.type, (data) => {
                        this.imgSrc = data;
                        this.load = false;
                    });
                };

                reader.readAsDataURL(file);

                this.setCroppedStatus(false);
            } else {
                this.load = false;
                alert("Sorry, FileReader API not supported");
            }
        },
        cropImage() {
            this.form.main_image = this.$refs.cropper.getCroppedCanvas().toDataURL();
            this.setCroppedStatus(true);
        },
        deleteImage() {
            this.form.main_image = null;
            this.imgSrc = null;
            this.form.cropper_main_image = true;
        },
        setCroppedStatus(state) {
            this.clearErrors();
            this.form.cropper_main_image = state;
        },
        text() {
            let text = null;

            if (this.pageType == 2 && !this.user) {
                text = (this.type === 'register')
                    ? Vue.prototype.$lang('formPage.text1')
                    : Vue.prototype.$lang('formPage.text2');
            }
            if (this.pageType == 1 && this.user) {
                text = Vue.prototype.$lang('formPage.text3');
            }
            if (this.pageType == 1 && !this.user) {
                text = Vue.prototype.$lang('formPage.text4');

                if (this.type === 'register') {
                    text = text + " <br><br> " + Vue.prototype.$lang('formPage.text5');
                }
            }
            return text;
        },
        validateDate() {
            let start = dayjs(this.form.start.year + '-' + Number(this.form.start.month) + '-' + Number(this.form.start.day), "YYYY-MM-DD");
            let end = dayjs(this.form.end.year + '-' + Number(this.form.end.month) + '-' + Number(this.form.end.day), "YYYY-MM-DD");

            return (end.diff(start) >= 0);
        },
        redirectTo(path) {
            return window.location.href = window.laravel.prefix + path;
        },
        createAndRedirectToPages() {
            this.forceRedirectToPath = '/cabinet/pages';

            this.create();
        },
        backToLocation() {
            this.$emit('update:title', this.$lang('formPage.title3'));

            this.setStep(2);
        },
        auth(user) {
            if (!!user.role && user.role.title !== 'user') {
                this.redirectTo("/cabinet/pages");
            }
        },
        scrollToCropperIfNeed(cropperId) {
            setTimeout(() => {
                if (Object.keys(this.cropperRules).indexOf(cropperId) > -1) {
                    document.getElementById(cropperId).scrollIntoView({block: "center", behavior: "smooth"});
                }
            }, 500);
        },
        getSuccessTitle(pageType) {
            return (pageType === this.pageTypes.full)
                ? this.$lang('formPage.success.title.full')
                : this.$lang('formPage.success.title');
        },
        sendOrder(order) {
            this.order = order;
            this.create();
        },
        checkSubscription() {
            reachGoalOplatit("formPage checkSubscription");

            this.validate(() => {
                if (!this.validateDate()) {
                    this.submitBlocked = false;

                    this.$appNotify.error(Vue.prototype.$lang('formPage.error1'));

                    return;
                }

                this.setSubscriptionId(this.subscriptionId)

                let burial = {
                    flag: this.burial,
                    id: this.burial_id
                };
                this.setBurialId(burial);

                if (this.user) {
                    let ids = {
                        master_id: this.master ? this.master : null,
                        user_id: this.responsible ? this.responsible : this.user.id,
                        partner_id: this.partner ? this.partner : null,
                    };
                    this.setIds(ids);
                }

                if (this.copyright) {
                    this.setStep(2);

                    return;
                }

                let isCreateBySubscription = this.pageType === this.pageTypes.full && this.subscriptionId;

                // создается ли при помощи подписки и не покупается из личного кабинета
                if (isCreateBySubscription && this.paymentType !== null) {
                    this.setPageType(this.pageTypes.full);
                    let subscription = window.laravel.subscription;

                    // Переход к оплате если исчерпан лимит расширенных страниц
                    if (subscription.subscription_type.max_page_count <= subscription.page_count) {
                        this.setStep(2);
                        return;
                    }

                    this.checkShortPageLimit()
                        .then(() => {
                            this.createPage(this.pageSlug)
                                .then((response) => {
                                    if (this.isAdmin) {
                                        this.redirectTo("/cabinet/page/" + response.data.slug);
                                    } else if (this.isPartner || this.isMaster) {
                                        if (this.notRedirect) {
                                            this.redirectTo( '/cabinet/responsibles');
                                        } else {
                                            this.redirectTo(this.burial ? '/cabinet/pages/related' : '/cabinet/pages');
                                        }
                                    } else if (this.toPA) {
                                        this.redirectTo("/cabinet/pages");
                                    } else {
                                        this.$nextTick(() => {
                                            if (this.copyright) {
                                                this.$dataLayer.push({'event': 'redirectToPay', 'title': 'РаК'});
                                                this.setStep(2);
                                            } else {
                                                this.$dataLayer.push({'event': 'pageCreated', 'title': 'Ра'});
                                                roistat.event.send('full_page_created');
                                            }
                                        });

                                        this.redirectTo(this.forceRedirectToPath ?? "/cabinet/page/" + response.data.slug);
                                    }
                                })
                                .catch((error) => {
                                    if (error.response.status === 400) {
                                        /*редирект, если создается с главной мастером без уазания ответственного*/
                                        this.redirectTo('/cabinet/pages');
                                    }

                                    this.creatingErrors = error.response.data;
                                });
                        })
                        .catch((error) => {
                            if (error.response.status === 403) {
                                //Редирект на форму если достигли лимит кратких страниц
                                this.$router.push({name: 'shortPageLimit'});
                            }
                        });
                } else {
                    this.setPageType(this.pageTypes.short);

                    this.checkShortPageLimit()
                        .then(() => {
                            this.createPage(this.pageSlug)
                                .then((response) => {
                                    if (this.isAdmin) {
                                        this.redirectTo("/cabinet/page/" + response.data.slug);
                                    } else if (this.isPartner || this.isMaster) {
                                        if (this.notRedirect) {
                                            this.redirectTo( '/cabinet/responsibles');
                                        } else {
                                            this.redirectTo(this.burial ? '/cabinet/pages/related' : '/cabinet/pages');
                                        }
                                    } else if (this.toPA) {
                                        this.redirectTo("/cabinet/pages");
                                    } else {
                                        this.$nextTick(() => {
                                            this.$dataLayer.push({'event': 'freePageCreated', 'title': 'Кр'});
                                            roistat.event.send('short_page_created');
                                        });

                                        this.redirectTo(this.forceRedirectToPath ?? "/cabinet/page/" + response.data.slug);
                                    }
                                })
                                .catch((error) => {
                                    if (error.response.status === 400) {
                                        /*редирект, если создается с главной мастером без уазания ответственного*/
                                        this.redirectTo('/cabinet/pages');
                                    }

                                    this.creatingErrors = error.response.data;
                                });
                        })
                        .catch((error) => {
                            if (error.response.status === 403) {
                                //Редирект на форму если достигли лимит кратких страниц
                                this.$router.push({name: 'shortPageLimit'});
                            }
                        });
                }
            }, {...this.form}, false, this.rules);
        },
    },
    watch: {
        type() {
            this.errorsAuth = null;
        },
        step() {
            if (this.step === 2 && this.pageType !== this.pageTypes.short) {
                this.setModal(1200);
            }
            else {
                this.setModal(800);
            }
        },
        delivery: function(val) {
            if (val) {
                this.setStep(3);
                this.$emit('update:title', this.$lang('formPage.title4'));
            }
        },
        noTable: function(val) {
            if (val) {
                this.delivery = null;
                this.setStep(3);
                this.$emit('update:title', this.$lang('formPage.title4'));
            }
        }
    }
}
</script>

<style>
.el-form-item .el-input__validateIcon {
    display: none;
}
</style>
